var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"call-tooltip",attrs:{"href":"#","data-toggle":"tooltip","data-placement":"bottom","title":_vm.title},on:{"click":function($event){$event.preventDefault();return _vm.send($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }